/**
 * Check if an error is a 404 (Not Found) error.
 * These are typically user navigation errors that clutter dashboards.
 */
export const is404Error = (error: Error | string): boolean => {
  // Check status property first (most reliable for structured errors)
  if (error instanceof Error) {
    const errorWithStatus = error as Error & { status?: string | number }
    if (errorWithStatus.status === 404 || errorWithStatus.status === '404') {
      return true
    }
  }

  // Fall back to message patterns for unstructured errors
  const errorMessage =
    typeof error === 'string' ? error : error.message || error.toString()

  // Common 404 patterns in error messages
  const notFoundPatterns = [/404/i, /not found/i, /page not found/i]

  return notFoundPatterns.some((pattern) => pattern.test(errorMessage))
}
